import { ChangeDetectorRef, Component } from '@angular/core';
import { SimpleTableComponent } from '../../generals/Components';
import { ApiService } from '../../services/api.service';
import { ProductItem } from '../../interfaces/interfaces';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'lib-productsearch',
  templateUrl: './productsearch.component.html',
  styleUrls: ['./productsearch.component.scss']
})
export class ProductsearchComponent extends SimpleTableComponent<ProductItem> {

  constructor(
    private apiServiceRef: ApiService,
    private changeDetectionRef: ChangeDetectorRef,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'products';
    this.config.header = 'Termék keresése';
  }

  ngOnInit(): void {
  }

  close(productItem: ProductItem = null): void {
    this.ref.close(productItem);
  }

}
